import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-field', 'required', 'Required');
Labels.set('ui-field', 'add', 'Add');
Labels.set('ui-field', 'remove', 'Remove');
